module.exports = __webpack_public_path__ + "img/Enkele_plooi.6cafe8a6.png";